module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"The Team"},"de":{"title":"Das Team"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/yaml-loader!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Team.vue
// module id = Lxem
// module chunks = 0